import { CtaButton, IBasicUserType } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledCtaButton = styled(CtaButton)`
  margin-top: ${rem('8px')};
`;

export const StyledEditButton = styled.button<IBasicUserType>`
  position: absolute;
  top: ${rem('2px')};
  right: 0;
  z-index: 100;
  display: flex;
  margin: 0;
  padding: 0;
  color: ${({ disabled, theme, user }) =>
    user &&
    (disabled ? theme.colors.cross.silverFox : theme.colors[user].main)};
  font-size: ${rem('16px')};
  font-weight: 700;
  text-decoration: underline;
  background-color: transparent;
  border: none;
  cursor: ${({ disabled }) => (disabled ? `default` : `pointer`)};
  appearance: none;
`;

export const StyledFieldset = styled.fieldset`
  margin: 0;
  padding: 0;
  border: none;
`;

export const StyledFieldList = styled.ul`
  margin: 0;
  padding: 0;
`;

export const StyledFieldListItem = styled.li`
  position: relative;
  list-style: none;

  &:not(:last-child) {
    margin-bottom: ${rem('24px')};
  }
`;
